const Input = ({ label, type, name, value, onChange, rows }) => {
    const isTextarea = type === 'textarea';
    const InputComponent = isTextarea ? 'textarea' : 'input';

    return (
        <div className="mb-3">
            <label htmlFor={name} className="form-label">{label}:</label>
            <InputComponent
                type={!isTextarea ? type : undefined}
                className="form-control"
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                required
                rows={rows}
            />
        </div>
    );
};

export default Input;
